export default __webpack_public_path__ + "static/media/SCDream-Thin.3f28bc17.otf";